import { createSlice } from "@reduxjs/toolkit";
import { COMPLIANCE_STATUS } from "../project-sheet/constants";

const initialState = {
	progress: null,
	globalSections: {},
	innerFields: [],
	originalCounters: {
		compliantCount: 0,
		criteriaCount: 0,
		nonCompliantCount: 0,
		notApplicableCount: 0,
		pendingCount: 0,
	},
	complianceFilters: [],
};

const projectSheetSlice = createSlice({
	name: "projectSheet",
	initialState,
	reducers: {
		setGlobalSections: (state, { payload }) => ({ ...state, globalSections: payload }),
		setOngoingProgress: (state, { payload }) => ({ ...state, progress: payload }),
		setInnerFields: (state, { payload }) => ({ ...state, innerFields: payload }),
		setPossibleValuesInnerFields: (state, { payload }) => {
			const { fieldUuid, possibleValues } = payload;
			return {
				...state,
				innerFields: state.innerFields.map(
					(inner) => (inner.fieldUuid === fieldUuid && { ...inner, possibleValues }) || inner
				),
			};
		},
		setComplianceFilters: (state, { payload }) => ({ ...state, complianceFilters: payload }),
		setOriginalCounters: (state, { payload }) => ({ ...state, originalCounters: payload }),
		updateCounters: (state, { payload }) => {
			const { newStatus, currentStatus } = payload;
			const statusKey = {
				[COMPLIANCE_STATUS.COMPLIANT]: "compliantCount",
				[COMPLIANCE_STATUS.NON_COMPLIANT]: "nonCompliantCount",
				[COMPLIANCE_STATUS.PENDING]: "pendingCount",
				[COMPLIANCE_STATUS.NOT_APPLICABLE]: "notApplicableCount",
			};
			const newCounters = { ...state.originalCounters };
			if (statusKey[newStatus]) {
				newCounters[statusKey[newStatus]] += 1;
			}
			if (statusKey[currentStatus]) {
				newCounters[statusKey[currentStatus]] -= 1;
			}
			return { ...state, originalCounters: newCounters };
		},
	},
});

export const {
	setGlobalSections,
	setOngoingProgress,
	setInnerFields,
	setPossibleValuesInnerFields,
	setComplianceFilters,
	updateCounters,
	setOriginalCounters,
} = projectSheetSlice.actions;
export default projectSheetSlice.reducer;
